/* Sticky mobile add-to-cart bar (CRO PDP Phase B, Option 3 hybrid).
   Markup in snippets/sticky-atc.liquid.

   Deliberately stateless about DOM nodes: third-party app scripts on the
   product page re-render parts of the main product section after load,
   which detaches any captured element references. Every handler re-queries
   the live DOM, and click/change use document-level delegation so behavior
   survives subtree replacement. Only `touched` (has the customer picked a
   size) lives in JS state. */
(function () {
  var touched = false;
  var initialized = false;

  function ctx() {
    var bar = document.querySelector('.sticky-atc');
    if (!bar) return null;
    var root = document.getElementById(bar.id.replace('StickyAtc-', 'MainProduct-'));
    if (!root) return null;
    return {
      bar: bar,
      submitBtn: root.querySelector('.product-form__submit'),
      picker: root.querySelector('variant-selects, variant-radios'),
      priceEl:
        root.querySelector('.price__container .price-item--sale.price-item--last') ||
        root.querySelector('.price__container .price-item--regular'),
    };
  }

  function ensureInit(c) {
    if (!initialized) {
      touched = c.bar.dataset.singleVariant === 'true' || !c.picker;
      initialized = true;
    }
  }

  function selectedSize(c) {
    if (!c.picker) return '';
    var radio = c.picker.querySelector('input[type="radio"]:checked');
    if (radio) return radio.value;
    var select = c.picker.querySelector('select');
    if (select && select.selectedOptions.length) return select.selectedOptions[0].textContent.trim();
    return '';
  }

  function sync(c) {
    var barBtn = c.bar.querySelector('.sticky-atc__button');
    var meta = c.bar.querySelector('.sticky-atc__meta');
    if (!barBtn || !meta || !c.submitBtn) return;
    var soldOut = c.submitBtn.disabled || c.submitBtn.getAttribute('aria-disabled') === 'true';
    barBtn.disabled = soldOut;
    if (soldOut) {
      barBtn.textContent = c.submitBtn.textContent.trim();
    } else {
      barBtn.textContent = touched ? c.bar.dataset.addLabel : c.bar.dataset.chooseLabel;
    }
    var size = touched ? selectedSize(c) : '';
    var price = c.priceEl ? c.priceEl.textContent.trim() : '';
    meta.textContent = size ? size + ' · ' + price : price;
  }

  function updateVisibility() {
    var c = ctx();
    if (!c || !c.submitBtn) return;
    ensureInit(c);
    if (c.submitBtn.getBoundingClientRect().bottom < 0) {
      sync(c);
      c.bar.classList.add('is-visible');
    } else {
      c.bar.classList.remove('is-visible');
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('variant-selects, variant-radios')) return;
    touched = true;
    initialized = true;
    var c = ctx();
    if (c) sync(c);
    /* the theme re-renders the price container async after a variant change */
    setTimeout(function () {
      var c2 = ctx();
      if (c2) sync(c2);
    }, 600);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sticky-atc__button');
    if (!btn || btn.disabled) return;
    var c = ctx();
    if (!c) return;
    if (!touched && c.picker) {
      c.picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (c.submitBtn) {
      c.submitBtn.click();
    }
  });

  window.addEventListener('scroll', updateVisibility, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateVisibility);
  } else {
    updateVisibility();
  }
})();
